module.exports = __webpack_public_path__ + "static/phone-frame-0588a80d4d5780f3106f1ed8a90adca6.png";